const apiUrl = process.env.REACT_APP_API_URL;

const getMaintenanceActivityBySPIDEID = (token, id, cb) => {
    fetch(`${apiUrl}/maintenanceactivities/byspidentityid/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getMaintenanceActivityBySPIDEID;
